import * as types from '../types/comanda'

const INITIAL_STATE = {
    loading: true,
    mesas: [],
    clientes: [],
    mesa: {},
    resumo_mesa: {},
    itemsLista: [],
    prodList: [],
    cliente_mesa_selecionado: 0,
    mesaSel: {},
    cardapio: [],
    prods_perpage: 10,
    prods_total: 0,
    prods_page: 0,
    cliSel: {id: 0, cpf: 0, nome: ''},
    clienteComandaSel: {id: 0, cpf: 0, nome: ''},
    dialog: {show: false, title:'', description: '',},
    listaClientes: [],
    listaCategorias: [],
    cardapio_pdv: [],
    cliPDV: '',
    cliPDVCpf: '',
    listaPedidospdv: [],
    resumoPedPDV: { total_qtd: 0, 
                    valor: 0, 
                    gorjeta: 0, 
                    total_com_servico: 0, 
                    cashback: 0 
                  },
    pedPDVSelect: '',
    pdv_pedido_selecionado: {
        id: '',
        referencia: '',
        cpf_nota: '',
        items: []
    },
    pdv_pedido_editar: {
        id: '',
        referencia: '',
        cpf_nota: '',
        items: [],
    }
}



export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case types.MESAS_LOADING:
            return {...state, loading: action.payload}
        case types.MESAS_LIST:
            return {...state, mesas: action.payload}
        case types.MESA_SELECTED:
            return {...state, mesaSel: action.payload}
        case types.SET_MESA:
            return {...state, mesa: action.payload}
        case types.CLIENTES_LOADING:
            return {...state, loading: action.payload}
        case types.ITEMS_LISTA:
            return {...state, itemsLista: action.payload}
        case types.CLIENTES_MESA_LISTA:
            return {...state, clientes: action.payload}
        case types.CLIENTE_MESA_SELECIONADO:
            return {...state, cliente_mesa_selecionado: action.payload}
        case types.LISTA_PROD:
            return {...state, prodList: action.payload}
        case types.CARDAPIO:
            return {...state, cardapio: action.payload}
        case types.SET_PROD_PAGE:
            return {...state, prods_page: action.payload}
        case types.SET_PROD_PERPAGE:
            return {...state, prods_perpage: action.payload}
        case types.SET_PROD_TOTAL:
            return {...state, prods_total: action.payload}
        case types.SET_PESQ_CLI:
            return {...state, cliSel: action.payload}
        case types.SET_CLI_COMANDA_SEL:
            return {...state, clienteComandaSel: action.payload}
        case types.SET_DIALOG:
            return {...state, dialog: action.payload}
        case types.CLIENTES_LIST:
            return {...state, listaClientes: action.payload}
        case types.LIST_CATEGORIAS:
            return {...state, listaCategorias: action.payload}
        case types.CARDAPIO_PDV:
            return {...state, cardapio_pdv: action.payload}
        case types.CLI_PDV:
            return {...state, cliPDV: action.payload}
        case types.CLI_PDV_CPF:
            return {...state, cliPDVCpf: action.payload}
        case types.LIST_PEDIDOS_PDV:
            return {...state, listaPedidospdv: action.payload}
        case types.RESUMO_PED_PDV:
            return {...state, resumoPedPDV: action.payload}
        case types.SET_PED_PDV:
            return {...state, pedPDVSelect: action.payload}
        case types.PEDIDO_PDV_EFETIVADO:
            return {...state, pdv_pedido_selecionado: {...state.pdv_pedido_selecionado, ...action.payload}}
        case types.PEDIDO_PDV_EDIT:
            return {...state, pdv_pedido_editar: action.payload}
        default:
            return state
    }
}